module.exports = __webpack_public_path__ + "static/media/sun.7c8e4c78.png";